
export const docExtensionsStr = ["doc", "docm", "docx", "docxf", "dot", "dotm", "dotx", "epub", "fodt", "fb2", "htm", "html", "mht", "odt", "oform", "ott", "oxps", "pdf", "rtf", "txt", "djvu", "xml", "xps"];

export const cellExtensionsStr = ["csv", "fods", "ots", "xls", "xlsb", "xlsm", "xlsx", "xlt", "xltm", "xltx"];

export const slideExtensionsStr = ["fodp", "odp", "otp", "pot", "potm", "potx", "pps", "ppsm", "ppsx", "ppt", "pptm", "pptx"];

export const imageExtensionsStr = ["canvas", "gif", "jpg", "jpeg", "png", "tiff", "raw", "eps", "ai", "psd", "svg"]

export const videoExtensionsStr = ["mp4", "vob", "wmv", "wmz", "wms", "avi", "mkv", "flv", "osp", "vsdc", "mpeg-4", "check", "mov"]

export const audioExtensionsStr = ["avi", "cda", "aac", "adt", "adts", "m4a", "mp3", "wav", "wma", "flac", "aac", "ogg", "aiff", "alac"]
